module.exports = __webpack_public_path__ + "img/AppStore.be27e080.png";